module.exports = __webpack_public_path__ + "@/assets/img/imac2.38556cb0.png";